import { data } from '../../svg/Remove/data';
import { makeIcon } from '../makeIcon';

export const Remove = makeIcon(data, 'remove', 'Remove');

export default Remove;
